/** Layout constants + state shape for the session detail split. */

/** `split` shows both columns, `hidden` collapses the panel, `full` hides the thread. */
export type PanelMode = 'split' | 'hidden' | 'full';

export const DEFAULT_PANEL_WIDTH = 620;
export const MIN_PANEL_WIDTH = 320;
/** The thread never gives up more than this, however wide the panel is dragged. */
export const MIN_THREAD_WIDTH = 360;

/** Explorer column inside the Files tab (was a hard-coded `w-56`). */
export const DEFAULT_TREE_WIDTH = 224;
export const MIN_TREE_WIDTH = 140;
export const MAX_TREE_WIDTH = 480;
